export default __webpack_public_path__ + "static/media/lareinalayout.d261f592.png";